/**
 * Varianten-Overlay für Produktkarten-Grids (Design-Handoff Overlay, Turn 13).
 * Öffnet vom "… wählen"-Button bzw. "+n" der Karte, rendert aus dem Varianten-JSON
 * der Karte (kein zweiter Roundtrip) und schließt den Kauf im Overlay ab.
 */
(function () {
  'use strict';

  var dialog = null;
  var config = null;
  var state = null; // { data, selection, card, trigger, media }

  var CART_SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
  ];

  function init() {
    dialog = document.getElementById('variant-modal');
    if (!dialog) return false;
    if (!config) {
      var script = dialog.querySelector('[data-vm-config]');
      try {
        config = JSON.parse(script.textContent);
      } catch (e) {
        config = null;
      }
    }
    return !!config;
  }

  function $(sel, root) {
    return (root || dialog).querySelector(sel);
  }

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  /* ===== Sortierung (§4) ===== */

  function sizeRank(value) {
    var key = String(value).toLowerCase().trim().replace(/[()]/g, '');
    var table = config.sizeOrder || {};
    if (Object.prototype.hasOwnProperty.call(table, key)) return table[key];

    // Numerisch: führende Zahl, Komma als Dezimaltrenner, Einheit normalisieren
    var match = key.replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    if (match) {
      var num = parseFloat(match[1]);
      if (/\bkg\b|\bl\b|liter/.test(key)) num *= 1000;
      return 10000 + num;
    }
    return 1e9; // Unbekanntes ans Ende
  }

  function sortedValues(data, axisIndex) {
    var seen = [];
    data.variants.forEach(function (v) {
      if (seen.indexOf(v.options[axisIndex]) === -1) seen.push(v.options[axisIndex]);
    });
    // Farbachse behält die Backend-Reihenfolge, nur Größen werden sortiert
    if (axisIndex === data.axis && (data.mode === 'swatches-choose' || data.mode === 'swatches-add')) return seen;
    return seen.slice().sort(function (a, b) {
      var ra = sizeRank(a), rb = sizeRank(b);
      if (ra === rb) return seen.indexOf(a) - seen.indexOf(b);
      return ra - rb;
    });
  }

  /* Optionswerte wie "XS (43 - 56 cm)" trennen: Chip zeigt die Größe,
     das Maß erscheint als Zeile unter den Chips (§2.5). */
  function splitValue(value) {
    var m = String(value).match(/^\s*(.+?)\s*\(([^()]+)\)\s*$/);
    if (!m) return { label: String(value), note: '' };
    return { label: m[1], note: m[2].replace(/\s*-\s*/g, '–') };
  }

  /* ===== Varianten-Matching ===== */

  function matching(data, selection) {
    return data.variants.filter(function (v) {
      return selection.every(function (val, i) { return val == null || v.options[i] === val; });
    });
  }

  function exact(data, selection) {
    if (selection.some(function (v) { return v == null; })) return null;
    return data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selection[i]; });
    }) || null;
  }

  function cheapest(list) {
    return list.reduce(function (min, v) { return v.priceCents < min.priceCents ? v : min; }, list[0]);
  }

  /* ===== Rendern ===== */

  function renderMedia() {
    var data = state.data;
    var variant = exact(data, state.selection) || cheapest(matching(data, state.selection));
    var hero = $('[data-vm-hero]');

    // Bilder der gewählten Farbe: 1. Alt-Tag-Set (#Gruppe_Wert),
    // 2. Varianten-Bilder derselben Farbe, 3. alle Bilder.
    // So stehen im Strip nie die anderen Farben.
    var selectedValue = state.selection[data.axis];
    var set = (data.imageSets || {})[selectedValue] || [];
    var images;
    if (set.length) {
      images = set.slice();
    } else {
      var sameColor = [];
      data.variants.forEach(function (v) {
        if (v.options[data.axis] === selectedValue && v.img && sameColor.indexOf(v.img) === -1) {
          sameColor.push(v.img);
        }
      });
      images = sameColor.length ? sameColor : state.media.slice();
    }
    var current = (set.length ? set[0] : (variant && variant.img)) || images[0] || '';
    if (current && images.indexOf(current) === -1) images.unshift(current);
    if (hero && current) {
      hero.src = current;
      hero.alt = data.title || '';
    }

    var badge = $('[data-vm-badge]');
    if (badge) {
      var pct = (variant && variant.compare)
        ? Math.round((1 - variant.priceCents / variant.compareCents) * 100)
        : 0;
        if (pct >= 3) {
        badge.textContent = '-' + pct + ' %';
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
    }

    var strip = $('[data-vm-thumbs]');
    if (!strip) return;
    strip.innerHTML = '';
    // Ein einzelnes Bild braucht keinen Strip
    strip.classList.toggle('hidden', images.length < 2);
    if (images.length < 2) return;
    var slots = images.slice(0, 4);
    var rest = images.length - 4;
    slots.forEach(function (src, i) {
      if (rest > 0 && i === 3) {
        var more = document.createElement('span');
        more.className = 'vm-thumb vm-thumb--more';
        more.textContent = '+' + (rest + 1);
        strip.appendChild(more);
        return;
      }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vm-thumb' + (src === current ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Bild ' + (i + 1));
      btn.dataset.vmThumb = src;
      var img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.loading = 'lazy';
      btn.appendChild(img);
      strip.appendChild(btn);
    });
  }

  function renderAxes() {
    var data = state.data;
    var host = $('[data-vm-axes]');
    host.innerHTML = '';

    data.optionNames.forEach(function (name, i) {
      var isColorAxis = i === data.axis && (data.mode === 'swatches-choose' || data.mode === 'swatches-add');
      var values = sortedValues(data, i);

      var axis = document.createElement('div');
      axis.className = 'vm-axis';

      var head = document.createElement('div');
      head.className = 'vm-axis-head';
      var label = document.createElement('span');
      label.className = 'vm-axis-label';
      label.textContent = state.selection[i]
        ? name + ' · ' + splitValue(state.selection[i]).label
        : name;
      head.appendChild(label);

      if (isColorAxis) {
        var count = document.createElement('span');
        count.className = 'vm-axis-meta';
        count.textContent = values.length + ' ' + config.labels.colors;
        head.appendChild(count);
      } else if (state.data.sizeChart) {
        var link = document.createElement('button');
        link.type = 'button';
        link.className = 'vm-sizechart-link';
        link.textContent = config.labels.sizeChart;
        link.dataset.vmSizechart = '1';
        head.appendChild(link);
      }
      axis.appendChild(head);

      var group = document.createElement('div');
      group.className = isColorAxis ? 'vm-swatches' : 'vm-chips';
      if (!isColorAxis && values.length >= 7) group.classList.add('vm-chips--dense');
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-label', name);

      values.forEach(function (value) {
        var probe = state.selection.slice();
        probe[i] = value;
        var possible = data.variants.some(function (v) {
          return probe.every(function (val, j) { return val == null || v.options[j] === val; }) && v.available;
        });

        var el = document.createElement('button');
        el.type = 'button';
        el.setAttribute('role', 'radio');
        el.dataset.vmAxis = i;
        el.dataset.vmValue = value;
        var active = state.selection[i] === value;
        el.setAttribute('aria-checked', active ? 'true' : 'false');

        if (isColorAxis) {
          el.className = 'vm-swatch' + (active ? ' is-active' : '');
          el.setAttribute('aria-label', name + ' ' + value);
          var swatch = (data.swatches || {})[value];
          if (swatch && swatch.color) {
            el.style.backgroundColor = swatch.color;
          } else if (swatch && swatch.img) {
            el.style.backgroundImage = 'url(' + swatch.img + ')';
          } else {
            el.style.backgroundColor = '#ECEADF';
          }
        } else {
          el.className = 'vm-chip' + (active ? ' is-active' : '');
          el.textContent = splitValue(value).label;
        }

        if (!possible) {
          el.setAttribute('aria-disabled', 'true');
          // Grund nur als Tooltip, nicht als Dauertext (§3)
          var other = state.selection.filter(function (v, j) { return j !== i && v; })[0];
          el.title = other ? 'In ' + other + ' nicht verfügbar' : config.labels.notAvailable;
        }
        group.appendChild(el);
      });
      axis.appendChild(group);

      if (!isColorAxis && state.selection[i]) {
        var note = splitValue(state.selection[i]).note;
        if (note) {
          var noteEl = document.createElement('div');
          noteEl.className = 'vm-axis-note';
          noteEl.textContent = note;
          axis.appendChild(noteEl);
        }
      }
      host.appendChild(axis);
    });
  }

  function renderBuy() {
    var data = state.data;
    var complete = !state.selection.some(function (v) { return v == null; });
    var variant = exact(data, state.selection);
    var pool = matching(data, state.selection);
    var ref = variant || (pool.length ? cheapest(pool) : data.variants[0]);
    if (!ref) return;

    var priceEl = $('[data-vm-price]');
    var compareEl = $('[data-vm-compare]');
    var savedEl = $('[data-vm-saved]');
    priceEl.textContent = (complete ? '' : 'ab ') + ref.price;
    if (ref.compare) {
      compareEl.textContent = ref.compare;
      compareEl.classList.remove('hidden');
      savedEl.textContent = config.labels.saved.replace('{amount}', money(ref.compareCents - ref.priceCents));
      savedEl.classList.remove('hidden');
    } else {
      compareEl.classList.add('hidden');
      savedEl.classList.add('hidden');
    }

    var unitEl = $('[data-vm-unit]');
    if (unitEl) {
      if (ref.unit) {
        unitEl.textContent = (complete ? '' : 'ab ') + ref.unit;
        unitEl.classList.remove('hidden');
      } else {
        unitEl.textContent = '';
        unitEl.classList.add('hidden');
      }
    }

    var stock = $('[data-vm-stock]');
    stock.classList.remove('vm-stock--low', 'vm-stock--out');
    if (complete && !ref.available) {
      stock.textContent = config.labels.soldOut;
      stock.classList.add('vm-stock--out');
    } else if (ref.qty !== null && ref.qty > 0 && ref.qty <= config.lowThreshold) {
      stock.textContent = config.labels.lowStock.replace('{n}', ref.qty);
      stock.classList.add('vm-stock--low');
    } else {
      stock.textContent = config.labels.inStock;
    }

    renderDelivery(ref.id);

    var cta = $('[data-vm-cta]');
    var label = $('[data-vm-cta-label]');
    $('[data-vm-id]').value = ref.id;
    if (complete && ref.available) {
      cta.classList.remove('vm-cta--incomplete');
      label.textContent = config.labels.addToCart + ' · ' + ref.price;
    } else if (complete) {
      cta.classList.add('vm-cta--incomplete');
      label.textContent = config.labels.soldOut;
    } else {
      cta.classList.add('vm-cta--incomplete');
      label.textContent = config.labels.addToCart + ' · ab ' + ref.price;
    }
    $('[data-vm-hint]').classList.add('hidden');
  }

  /* ===== Lieferdatum über Arrivedate (§5) ===== */

  function renderDelivery(variantId) {
    var host = $('[data-vm-delivery]');
    if (!host || !config.arrivedateId) return;
    host.innerHTML = '';
    var mount = document.createElement('div');
    mount.id = 'arrivedate';
    mount.setAttribute('data-id', config.arrivedateId);
    mount.setAttribute('data-variant', variantId);
    host.appendChild(mount);
    // Loader erneut anstoßen; das Skript rendert in #arrivedate
    var s = document.createElement('script');
    s.src = 'https://cdn.arrivedate.com/js/shopify.js';
    s.async = true;
    host.appendChild(s);
  }

  /* ===== Öffnen / Schließen ===== */

  function open(card, trigger) {
    if (!init()) return;
    var pcv = card.querySelector('.pcv');
    var script = pcv && pcv.querySelector('.pcv-data');
    if (!script) return;
    var data;
    try {
      data = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var currentId = parseInt(pcv.dataset.currentId || data.selectedId, 10);
    var current = data.variants.find(function (v) { return v.id === currentId; }) || data.variants[0];

    var titleEl = card.querySelector('.product-card-title');
    var vendorEl = card.querySelector('.product-card-vendor');
    data.title = titleEl ? titleEl.textContent.trim() : '';

    var media = [];
    data.variants.forEach(function (v) {
      if (v.img && media.indexOf(v.img) === -1) media.push(v.img);
    });
    var cardImg = card.querySelector('.product-primary-image');
    if (cardImg && cardImg.src && media.indexOf(cardImg.src) === -1) media.unshift(cardImg.src);

    state = {
      data: data,
      // Leitachse (Farbe/Hauptachse) vorbelegt, zweite Achse offen -> Zustand B
      selection: current.options.map(function (val, i) { return i === data.axis ? val : null; }),
      card: card,
      trigger: trigger,
      media: media
    };

    $('[data-vm-vendor]').textContent = vendorEl ? vendorEl.textContent.trim() : '';
    $('[data-vm-title]').textContent = data.title;

    var rating = $('[data-vm-rating]');
    var cardRating = card.querySelector('.star-rating-container');
    if (cardRating) {
      rating.innerHTML = '<span class="vm-stars">★★★★★</span><span>' + cardRating.textContent.trim() + '</span>';
      rating.classList.remove('hidden');
    } else {
      rating.classList.add('hidden');
    }

    dialog.querySelector('.vm-state--select').classList.remove('hidden');
    dialog.querySelector('.vm-state--done').classList.add('hidden');
    $('[data-vm-qty]').value = 1;
    $('.vm-live').textContent = '';

    renderAll();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.body.classList.add('vm-open');
  }

  function renderAll() {
    renderMedia();
    renderAxes();
    renderBuy();
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.body.classList.remove('vm-open');
    if (state && state.trigger) state.trigger.focus();
  }

  /* ===== Warenkorb (§8) ===== */

  function renderCartSections(response) {
    var parsed = {};
    CART_SECTIONS.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host || !response.sections || !response.sections[section.section]) return;
      if (!parsed[section.section]) {
        parsed[section.section] = new DOMParser().parseFromString(response.sections[section.section], 'text/html');
      }
      var target = host.querySelector(section.selector) || host;
      var source = parsed[section.section].querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart:item-added', {
        product: response.hasOwnProperty('items') ? response.items[0] : response
      });
    }
  }

  function submit(form) {
    var complete = !state.selection.some(function (v) { return v == null; });
    if (!complete) {
      // Hinweis erst beim Klick (§6)
      var hint = $('[data-vm-hint]');
      hint.classList.remove('hidden');
      var chips = dialog.querySelector('.vm-chips');
      if (chips) {
        chips.classList.remove('vm-chips--flash');
        void chips.offsetWidth;
        chips.classList.add('vm-chips--flash');
      }
      return;
    }
    var cta = $('[data-vm-cta]');
    var live = $('.vm-live');
    live.textContent = '';
    cta.setAttribute('aria-busy', 'true');

    var formData = new FormData(form);
    formData.set('quantity', $('[data-vm-qty]').value || 1);
    formData.append('sections', CART_SECTIONS.map(function (s) { return s.section; }).join(','));
    formData.append('sections_url', window.location.pathname);

    fetch(window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          live.textContent = res.data.description || res.data.message || 'Konnte nicht hinzugefügt werden.';
          return;
        }
        renderCartSections(res.data);
        showDone();
      })
      .catch(function () {
        live.textContent = 'Netzwerkfehler — bitte erneut versuchen.';
      })
      .finally(function () {
        cta.removeAttribute('aria-busy');
      });
  }

  /* ===== Zustand C (§7) ===== */

  function updateProgress(total) {
    var sub = $('[data-vm-done-sub]');
    var bar = $('[data-vm-progress]');
    if (!sub || !bar) return;
    if (!config.freeShippingEnabled || !config.freeShippingMinimum) {
      sub.textContent = '';
      bar.style.width = '0';
      return;
    }
    var left = config.freeShippingMinimum - total;
    if (left > 0) {
      sub.textContent = config.labels.freeShippingLeft.replace('{amount}', money(left));
      bar.style.width = Math.min(100, (total / config.freeShippingMinimum) * 100) + '%';
    } else {
      sub.textContent = config.labels.freeShippingReached;
      bar.style.width = '100%';
    }
  }

  function refreshCartTotal() {
    // Achtung: die Antwort von /cart/add.js ist die Zeilenposition, nicht der Warenkorb.
    // Der Gesamtwert muss separat geholt werden.
    var url = (window.theme && theme.routes ? theme.routes.cart_url : '/cart') + '.js';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          config.cartTotal = cart.total_price;
          updateProgress(cart.total_price);
        }
      })
      .catch(function () {});
  }

  function showDone() {
    var data = state.data;
    var variant = exact(data, state.selection);
    var qty = parseInt($('[data-vm-qty]').value, 10) || 1;

    $('[data-vm-done-title]').textContent = config.labels.inCart + data.title +
      (variant ? ', ' + variant.options.filter(Boolean).join(', ') : '');

    // Sofort mit dem geschätzten Wert zeichnen, dann mit dem echten Warenkorb korrigieren
    updateProgress((config.cartTotal || 0) + (variant ? variant.priceCents : 0) * qty);
    refreshCartTotal();

    dialog.querySelector('.vm-state--select').classList.add('hidden');
    dialog.querySelector('.vm-state--done').classList.remove('hidden');
    loadUpsell(data.productId);
  }

  function loadUpsell(productId) {
    var box = $('[data-vm-upsell]');
    var host = $('[data-vm-upsell-items]');
    if (!box || !host || !productId || !config.recommendationsUrl) return;
    box.classList.add('hidden');
    host.innerHTML = '';

    // Gepflegte Ergänzungsprodukte (Search & Discovery), sonst algorithmische Empfehlungen
    fetchRecommendations(productId, 'complementary')
      .then(function (items) {
        return items.length ? items : fetchRecommendations(productId, 'related');
      })
      .then(function (items) {
        // Einvariantige Artikel landen per "+" direkt im Warenkorb; Artikel mit
        // mehreren Varianten führen zum Produkt, weil der Klick sonst mehrdeutig wäre (§7.3).
        var usable = items.filter(function (p) { return p.available; }).slice(0, 2);
        if (!usable.length) return;
        usable.forEach(function (p) {
          var row = document.createElement('div');
          row.className = 'vm-upsell-item';
          var action = p.variants === 1
            ? '<button type="button" class="vm-upsell-add" data-vm-upsell-add="' + p.variantId + '" aria-label="' + p.title + ' hinzufügen">+</button>'
            : '<a class="vm-upsell-add" href="' + p.url + '" aria-label="' + p.title + ' ansehen">›</a>';
          row.innerHTML =
            '<div class="vm-upsell-thumb">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="vm-upsell-title">' + p.title + '</div>' +
            '<div class="vm-upsell-price">' + p.price + '</div>' + action;
          host.appendChild(row);
        });
        box.classList.remove('hidden');
      })
      .catch(function () {});
  }

  function fetchRecommendations(productId, intent) {
    // JSON-Endpunkt: liefert Preis, Bild und Varianten direkt.
    // "complementary" = die in Search & Discovery gepflegten Ergänzungsprodukte.
    var url = config.recommendationsUrl + '.json?product_id=' + productId +
      '&limit=6&intent=' + intent;
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (payload) {
        return (payload.products || []).map(function (p) {
          var variant = p.variants && p.variants.length ? p.variants[0] : null;
          var varies = p.price_varies || (p.variants && p.variants.length > 1);
          return {
            title: p.title,
            price: (varies ? 'ab ' : '') + money(p.price_min != null ? p.price_min : p.price),
            img: p.featured_image || (p.images && p.images[0]) || '',
            url: p.url || '',
            variantId: variant ? variant.id : '',
            variants: p.variants ? p.variants.length : 0,
            available: p.available
          };
        });
      })
      .catch(function () { return []; });
  }

  function addUpsell(variantId, button) {
    button.setAttribute('aria-busy', 'true');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', CART_SECTIONS.map(function (s) { return s.section; }).join(','));
    formData.append('sections_url', window.location.pathname);
    fetch(window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) return;
        renderCartSections(res);
        button.textContent = '✓';
        refreshCartTotal();
      })
      .catch(function () {})
      .finally(function () { button.removeAttribute('aria-busy'); });
  }

  /* ===== Events ===== */

  document.addEventListener('click', function (e) {
    // Öffnen
    var trigger = e.target.closest('.pcv-open-sheet');
    if (trigger) {
      var card = trigger.closest('product-card');
      if (card && init()) {
        e.preventDefault();
        open(card, trigger);
      }
      return;
    }
    if (!dialog) return;

    if (e.target.closest('.vm-close') || e.target.closest('[data-vm-continue]')) {
      close();
      return;
    }
    if (e.target === dialog) { // Backdrop
      close();
      return;
    }

    var sizechartLink = e.target.closest('[data-vm-sizechart]');
    if (sizechartLink && state) {
      var panel = document.getElementById('vm-sizechart');
      panel.querySelector('[data-vm-sizechart-body]').innerHTML = state.data.sizeChart || '';
      panel.hidden = false;
      return;
    }
    if (e.target.closest('[data-vm-sizechart-close]') || e.target.id === 'vm-sizechart') {
      document.getElementById('vm-sizechart').hidden = true;
      return;
    }

    var thumb = e.target.closest('[data-vm-thumb]');
    if (thumb) {
      var hero = $('[data-vm-hero]');
      if (hero) hero.src = thumb.dataset.vmThumb;
      dialog.querySelectorAll('.vm-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      return;
    }

    var option = e.target.closest('[data-vm-axis]');
    if (option && state) {
      var axis = parseInt(option.dataset.vmAxis, 10);
      var value = option.dataset.vmValue;
      if (option.getAttribute('aria-disabled') === 'true') {
        // Leitachse darf trotzdem wechseln, deselektiert dann die andere Achse (§3)
        if (axis === state.data.axis) {
          state.selection = state.selection.map(function (v, i) { return i === axis ? value : null; });
          renderAll();
        }
        return;
      }
      state.selection[axis] = value;
      renderAll();
      return;
    }

    var step = e.target.closest('[data-vm-step]');
    if (step) {
      var input = $('[data-vm-qty]');
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.vmStep, 10);
      input.value = next < 1 ? 1 : next;
      return;
    }

    var upsellAdd = e.target.closest('[data-vm-upsell-add]');
    if (upsellAdd) {
      addUpsell(upsellAdd.dataset.vmUpsellAdd, upsellAdd);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-vm-form]');
    if (!form || !state) return;
    e.preventDefault();
    submit(form);
  });

  document.addEventListener('close', function (e) {
    if (e.target === dialog) document.body.classList.remove('vm-open');
  }, true);

  // Pfeiltasten innerhalb einer Radiogroup (§10)
  document.addEventListener('keydown', function (e) {
    if (!dialog || !dialog.open) return;
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var current = document.activeElement;
    if (!current || !current.dataset || current.dataset.vmAxis === undefined) return;
    var group = current.parentNode;
    var items = Array.prototype.slice.call(group.querySelectorAll('[data-vm-axis]'));
    var idx = items.indexOf(current);
    var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
    if (items[next]) {
      e.preventDefault();
      items[next].focus();
    }
  });
})();
